<template>
    <div class="comProgress"
        v-if="getProgress<100">
        <b-progress v-model="getProgress"
            :precision="1"></b-progress>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters(['getProgress']),
        // progress() {
        //     if (this.getProgress.length > 0) {
        //         return this.$store.state.progress.reduce((sum, progressObj) => {
        //             sum += progressObj.val;
        //             return sum;
        //         }, 0) / this.getProgress.lengt
        //     } else {
        //         return 0;
        //     }
        // }
    },
    // data: () => ({
    //     progress: this.getProgress,
    // }),
    // watch: {
    //     getProgress: {
    //         handler: function (val) {
    //             console.log(val);
    //             this.showProgress = false;
    //             val.forEach((valObj) => {
    //                 if (valObj.val > 0 && valObj.val < 100) this.showProgress = true;
    //             })
    //         },
    //         deep: true
    //     }
    // }

}

</script>

<style lang="scss">
@import '../style/variable.scss';
.comProgress {
    @include fullScreenCenter;
    z-index: 9999;
    background-color: $halfTransparent;
    flex-direction: column;
    .progress {
        width: 80%;
        margin: 2px;
    }
}
</style>



// WEBPACK FOOTER //
// com-progress.vue?783abb5c